/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  GetApiV1TutoraiDocuments200,
  GetApiV1TutoraiDocuments401,
  GetApiV1TutoraiDocuments500,
  GetApiV1TutoraiDocumentsQueryParams,
  GetApiV1TutoraiDocumentsQueryResponse,
} from "../../types/tutorAIDocumentosController/GetApiV1TutoraiDocuments.ts";
import { tutorAIDocumentSummaryViewModelSchema } from "../tutorAIDocumentSummaryViewModelSchema.ts";

export const getApiV1TutoraiDocumentsQueryParamsSchema = z
  .object({
    classStudentId: z.optional(z.coerce.number().int()),
  })
  .optional() as unknown as ToZod<GetApiV1TutoraiDocumentsQueryParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const getApiV1TutoraiDocuments200Schema = z.array(
  z.lazy(() => tutorAIDocumentSummaryViewModelSchema),
) as unknown as ToZod<GetApiV1TutoraiDocuments200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const getApiV1TutoraiDocuments401Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiDocuments401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const getApiV1TutoraiDocuments500Schema =
  z.any() as unknown as ToZod<GetApiV1TutoraiDocuments500>;

export const getApiV1TutoraiDocumentsQueryResponseSchema = z.lazy(
  () => getApiV1TutoraiDocuments200Schema,
) as unknown as ToZod<GetApiV1TutoraiDocumentsQueryResponse>;
